// extracted by mini-css-extract-plugin
module.exports = {"slider":"slider-module--slider--L3lc-","navButton":"slider-module--nav-button--3ly6J","noShadow":"slider-module--no-shadow--3Eg31","row":"slider-module--row--16nzO"};